import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider, createClient } from 'urql';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import ScrollToTop from './components/ScrollToTop';
import GAListener from './helpers/GAListener';

const client = createClient({
  url: '/.netlify/functions/graphql',
});

ReactDOM.render(
  <BrowserRouter>
    <GAListener trackingId="UA-151181277-1">
      <Provider value={client}>
        <ScrollToTop />
        <App />
      </Provider>
    </GAListener>
  </BrowserRouter>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
